module.exports = __webpack_public_path__ + "img/main_tikoku.bd138eed.png";